/* @flow weak */
export default {
  SIGN_UP: {
    google_conversion_id: 995958353,
    google_conversion_language: 'en',
    google_conversion_format: '3',
    google_conversion_color: 'ffffff',
    google_conversion_label: 'yGxACJyoyWgQ0bz02gM',
    google_remarketing_only: false,
  },
};



// WEBPACK FOOTER //
// ./src/constants/GoogleConversionConstants.js